import styled from "styled-components";
import {
  AMBER_COLOR,
  BLACK_COLOR,
  GREEN_TAG_FONT_COLOR,
  NAVLINK_COLOR,
  WHITE_COLOR,
} from "constants/style/color";

export const DateDiv = styled.span`
  background: ${WHITE_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  height: 0.635rem;
`;

export const WarrantyStatusText = styled.span<{ $status: string }>`
  color: ${({ $status }) =>
    $status === "active"
      ? GREEN_TAG_FONT_COLOR
      : $status === "inactive"
      ? AMBER_COLOR
      : BLACK_COLOR};
  text-transform: capitalize;
`;

export const PdfLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${NAVLINK_COLOR};
  text-decoration: underline;
  font-size: 0.875rem;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    opacity: 0.85;
  }
`;

export const ActionIconsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
